import { useCallback, useRef } from "react";

interface ErrorKey {
  status?: number;
  message: string;
}

export function useErrorDeduplication(timeWindow = 5000) {
  const recentErrorsRef = useRef(new Map<string, number>());

  const shouldShowError = useCallback(
    (error: ErrorKey): boolean => {
      const key = error.status !== undefined ? `${error.status}-${error.message}` : error.message;
      const now = Date.now();
      const lastShown = recentErrorsRef.current.get(key);

      if (!lastShown || now - lastShown > timeWindow) {
        recentErrorsRef.current.set(key, now);

        const cutoff = now - timeWindow;
        for (const [entryKey, timestamp] of recentErrorsRef.current.entries()) {
          if (timestamp < cutoff) {
            recentErrorsRef.current.delete(entryKey);
          }
        }

        return true;
      }

      return false;
    },
    [timeWindow],
  );

  return { shouldShowError };
}
